import React, { memo } from "react";
import { RCCGrid, RCCIcon, RCCProgress } from "react-common-components";
import UserColumn from "src/components/DefaultColumnsList/User";
import List from "src/components/List";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { ReactComponent as SprintIcon } from "src/assets/icons/sprint-icon.svg";
import WrapText from "src/components/WrapText";
import { PhaseAgile } from "../../interface";
import { IListProjectsLevel } from "./interface";
import OverflowSpan from "./styles";
import HoursProjectsContainer from "../HoursProjects/container";

const ListProjectsLevel: React.FC<IListProjectsLevel> = ({
	data,
	filter,
	showHeader,
	imageOnly,
	options
}) => {
	const { translate, currentLanguage } = useTranslation();

	const viewInfo = (row: any) => {
		// eslint-disable-next-line no-prototype-builtins
		if(!row.hasOwnProperty("agile")){
			return true;
		// eslint-disable-next-line no-prototype-builtins
		}if(row.hasOwnProperty("agile") && (row.agile === undefined || row.agile === PhaseAgile.SPRINT)){
			return true;
		}
		return false;
	};

	const colProject = (row: any) => (
		<OverflowSpan>
			{
				// eslint-disable-next-line no-prototype-builtins
				(row.hasOwnProperty("agile") && !row.agile ) && (
					<RCCIcon 
						name="list"	
						size={14}
						style={{marginRight:"0.5rem"}}				
					/>
				)
			}
			{
				// eslint-disable-next-line no-prototype-builtins
				(row.hasOwnProperty("agile") && (row.agile === PhaseAgile.BACKLOG)) && (
					<RCCIcon 
						name="stack"
						size={14}	
						style={{marginRight:"0.5rem"}}				
					/>
				)
			}
			{
				// eslint-disable-next-line no-prototype-builtins
				(row.hasOwnProperty("agile") && (row.agile === PhaseAgile.SPRINT)) && (
					<SprintIcon style={{ marginRight: "0.5rem", width: "14px", height: "14px" }}/>
				)}	

			<WrapText lineClamp={2} title={row.name}>
				{row.name}
			</WrapText>
		</OverflowSpan>
	);

	const colUser = (row: any) => (
		<>
			{
				
				viewInfo(row) && row.users.length !== 0 &&
				<>
					{
						row.users.length > 1 ? 
							<UserColumn 
								list={row.users || []}
								imageOnly={imageOnly}
							/>
							:
							<UserColumn 
								name={row.users[0].name}
								image={row.users[0].image}
								imageOnly={imageOnly}
							/>
					}
				</>
			}
		</>
	);

	const colPeriod = (row: any) => (
		<RCCGrid 
			item
			container
		>
			<div style={{marginRight: "10px"}}>
				{
					row.controlHours &&
					<HoursProjectsContainer projectId={row.id}/>
				}
			</div>
			<div>
				{
					viewInfo(row) &&
					<RCCGrid container item>
						<RCCIcon 
							className="head-title"
							name="calendar"
							size={16}
							style={{marginRight: "4px"}}
						/>
						{formatDate(row.startDate, currentLanguage)} - {formatDate(row.endDate, currentLanguage)}
					</RCCGrid>
				}
			</div>
				
		</RCCGrid>
	);

	const colPercentConclusion = (row: any) => (
		<RCCGrid
			container
			item
			alignItems="center"
			style={{ margin: "4px" }}
		>
			{
				viewInfo(row) &&
				<RCCProgress 
					color={`var(--${row.perConclusionColor})`}
					layout="line"
					value={row.perConclusion || 0}
				/>
			}
		</RCCGrid>
	);

	const colPercentPrevision = (row: any) => (
		<RCCGrid
			container
			item
			alignItems="center"
			style={{ margin: "4px" }}
		>
			{
				viewInfo(row) &&
				<RCCProgress 
					layout="line"
					value={row.perPrevision || 0}
				/>
			}
		</RCCGrid>
	);

	const colBadge = (row: any) => (
		<RCCGrid container justifyContent="center">{row.completed || 0}/{row.count || 0}</RCCGrid>
	);

	return(
		<List 
			showHeader={showHeader}
			filter={filter}
			data={data}
			columns={[
				{
					idColumn: "name",
					nameColumn: `${translate("Projeto")} | ${translate("Fase")}`,
					xs: 12,
					sm: 4,
					truncate: true,
					justify: "left",
					cellRenderer: colProject
				},
				{
					idColumn: "user",
					nameColumn: translate("Responsável"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: colUser
				},
				{
					idColumn: "period",
					nameColumn: translate("Período"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: colPeriod
				},
				{
					idColumn: "percConclusao",
					nameColumn: translate("% Conclusão"),
					justify: "left",
					xs: 12,
					sm: 1,
					cellRenderer: colPercentConclusion
				},
				{
					idColumn: "percPrevisto",
					nameColumn: translate("% Previsto"),
					justify: "left",
					xs: 12,
					sm: 1,
					hidden: ["sm"],
					cellRenderer: colPercentPrevision
				},
				{
					idColumn: "details",
					nameColumn: translate("Ações completadas"),
					justify: "left",
					xs: 12,
					sm: 1,
					hidden: ["sm"],
					cellRenderer: colBadge
				},
				{
					idColumn: "options",
					nameColumn: " ",
					xs: 12,
					sm: 1,
					cellRenderer: options
				}]}
			layout="table"
		/>
	);};

export default memo(ListProjectsLevel);
